export const LABEL_FOR_UNKNOWN = '–';
export const FEEDBACK_BUTTON_ID = 'feedback-button';
export const FEEDBACK_TAB_ID = 'feedback-tab';
export const UNADDRESSED_EMISSIONS_ID = 'UNADDRESSED_EMISSIONS_ID';
/**
 * Used for the abatement series when the abatement is shown together with the remaining emissions series.
 */
export const ABATEMENT_SERIES_ID = 'abatementSeriesId';

export enum STATIC_DASHBOARD_IDS {
  ENERGY_PRODUCTION_ID = 'ENERGY_PRODUCTION_ID',
  ENERGY_PRODUCTION_FULL_ID = 'ENERGY_PRODUCTION_FULL_ID',
  REMAINING_EMISSIONS_ID = 'REMAINING_EMISSIONS_ID',
  MAIN_GAP_ID = 'MAIN_GAP_ID',
  OTHER_REDUCTION_ID = 'OTHER_REDUCTION_ID',
  REFERENCE_ID = 'REFERENCE_ID',
  SCENARIO_EMISSIONS_ID = 'SCENARIO_EMISSIONS_ID',
  GOAL_ID = 'GOAL_ID',
  HISTORICAL_EMISSIONS_ID = 'HISTORICAL_EMISSIONS_ID',
  OUTCOME_ID = 'OUTCOME_ID',
  TRANSITION_ID = 'TRANSITION_ID',
  CARBON_ABATEMENT_ID = 'CARBON_ABATEMENT_ID',
  EMISSION_SINK_ID = 'EMISSION_SINK_ID',
}

export const STATIC_DEFAULT_DIAGRAM_HEADERS = [
  'Emissions reductions required',
  'Utsläppsminskningar som behövs',
  'Benötigte Emissionsreduktion',
  'Reducción de emisiones necesaria',
  "Réductions d'émissions nécessaires",
  'Emission reductions required',
];
